import { useEffect } from 'react'

import Grid from '../components/grid'
import { setCurrentPath } from '../state/ui'
import { useDownloaded } from '../queries/media'

export default function Downloaded() {
  const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useDownloaded()

  useEffect(() => {
    setCurrentPath([])
  }, [])

  return (
    <Grid
      shows={data ?? []}
      infiniteFunc={() => {
        if (hasNextPage && !isFetchingNextPage) fetchNextPage()
      }}
    />
  )
}
